import type { ColorName } from "metabase/ui/colors";
import type {
  CardType,
  Collection,
  CollectionItemModel,
  CollectionType,
  IconName,
  SearchModel,
  VisualizationDisplay,
} from "metabase-types/api";

export type IconModel =
  | SearchModel
  | CollectionItemModel
  | "model"
  | "schema"
  | "timeline"
  | "question"
  | "transform"
  | "user"
  | "nativequerysnippet"
  | "pythonlibrary"
  | "glossary"
  | "dataapp"
  | "transformtest";

export type ObjectWithModel = {
  id?: unknown;
  model: IconModel;
  authority_level?: "official" | string | null;
  collection_authority_level?: "official" | string | null;
  moderated_status?: "verified" | string | null;
  display?: VisualizationDisplay | null;
  type?: CollectionType | CardType;
  collection_type?: CollectionType;
  location?: Collection["location"];
  effective_location?: Collection["location"];
  is_personal?: boolean;
  is_remote_synced?: boolean;
  is_library_root?: boolean;
};

export const modelIconMap: Record<IconModel, IconName> = {
  collection: "folder",
  database: "database",
  table: "table",
  dataset: "model",
  schema: "folder_database",
  action: "bolt",
  "indexed-entity": "index",
  dashboard: "dashboard",
  question: "table2",
  model: "model",
  card: "table2",
  segment: "segment",
  measure: "ruler",
  metric: "metric",
  snippet: "snippet",
  nativequerysnippet: "snippet",
  document: "document",
  timeline: "calendar",
  transform: "transform",
  user: "person",
  pythonlibrary: "code_block",
  glossary: "glossary",
  exploration: "telescope",
  dataapp: "app",
  "data-app": "app",
  transformtest: "test_tube",
};

export type IconData = {
  name: IconName;
  color?: ColorName;
  iconUrl?: string;
  tooltip?: string;
};
